import React, { Fragment } from "react";
import Head from "../../layout/Head";
import Footer from "../Shear/Footer/Footer";
import Header from "../Shear/Header/Header";
import About from "./About";
import AwesomeServices from "./AwesomeServices/AwesomeServices";
import HeroSection from "./HeroSection";
import OurLatestBlog from "./OurLatestBlog/OurLatestBlog.jsx";
import SuccessBox from "./SuccessBox";
import Testimonials from "./Testimonials";
import WhyChooseUs from "./WhyChooseUs/WhyChooseUs";
import ScrollToTop from "../Shear/ScrollToTop.js";

const Home = () => {
  console.log("hi");
  return (
    <Fragment>
      <Head
        Title="Home"
        href="/"
        description="IT Services Providers are companies that offer a range of IT services and solutions to help organizations manage their technology infrastructure | Home Pages"
      />
      <Header />
      <HeroSection />
      <About />
      <AwesomeServices />
      <SuccessBox />
      <WhyChooseUs />

      <Testimonials />
      <OurLatestBlog />
      <ScrollToTop />
      <Footer />
    </Fragment>
  );
};

export default Home;
